export const optionMapping = {
  'overview-audience-metrics': 'overview-audience-metrics',
  'overview-spi-widget': 'overview-spi-widget',
  'overview-sub-opportunities': 'overview-sub-opportunities',
  'overview-dimension-tables': 'overview-dimension-tables',
  base: 'base',
};

export const optionNameMapping = {
  'overview-audience-metrics': 'Audience Metrics',
  'overview-spi-widget': 'SPI',
  'overview-sub-opportunities': 'Improvement Opportunities',
  'overview-dimension-tables': 'Dimension Panels',
  'dimension-table': 'Top Trends',
  'dimension-viewers-table': 'Top Impacted Viewers',
};

export const sectionDisplayOrder = [
  'base',
  'overview-audience-metrics',
  'overview-spi-widget',
  'overview-sub-opportunities',
  'overview-dimension-tables',
];

export const hiddenOptions = ['base'];
